import { render, staticRenderFns } from "./ArticleInfoNormalTemplate.vue?vue&type=template&id=26ce6f3a&scoped=true"
import script from "./ArticleInfoNormalTemplate.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoNormalTemplate.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoNormalTemplate.vue?vue&type=style&index=0&id=26ce6f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ce6f3a",
  null
  
)

export default component.exports